import { Link } from "react-router-dom";
import { ImageOff } from "lucide-react";
import { getImageVariants } from "../../lib/imageVariants";

export default function CategoryCard({ category }) {
  const { thumb, medium } = getImageVariants(category.imageUrl);

  return (
    <Link to={`/category/${category.slug}`} className="group block">
      <div className="relative aspect-[4/3] overflow-hidden rounded-2xl bg-mono/[0.03] shadow-card">
        {medium ? (
          <img
            src={medium}
            srcSet={`${thumb} 200w, ${medium} 800w`}
            sizes="(min-width: 1024px) 22vw, 45vw"
            width={400}
            height={300}
            loading="lazy"
            alt={category.name}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-mono/[0.05]">
            <ImageOff size={28} className="text-mono/20" />
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/0 to-black/0" />
        <span className="absolute bottom-3 left-3 right-3 font-serif text-base text-white drop-shadow">
          {category.name}
        </span>
      </div>
    </Link>
  );
}
